import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import {permissionCodes} from 'modules/permissions/contants'
import React from 'react'
import {BiTrash} from 'react-icons/bi'
import {BsInfoCircle} from 'react-icons/bs'
import {IoSettingsOutline} from 'react-icons/io5'
import {RiSettings3Line, RiSubscript} from 'react-icons/ri'
import {withRouter} from 'react-router-dom'
import {compose, withProps} from 'recompose'
import {notFoundOnError, withAccessPermissions} from 'views/AppLocals/composers'
import {AppEntities} from 'views/AppLocals/enums'
import {createCheckPermissions} from 'views/AppLocals/factory/createCheckPermissions'
import {ContextActionTypes} from 'views/AppLocals/factory/createContextMenu'
import {createSettingModule} from 'views/AppLocals/factory/createModule'
import {bindingRouteSearch} from 'views/Shared/components/PagerControls'
import {CourseClassesManager} from 'views/Workspace/Course/containers/CourseClasses'
import createDeleteEntity from '../../factory/createDeleteEntity'
import CourseContext from '../CourseContext'
import {CourseSubjectList} from '../CourseSet/CourseSubjectForm'
import CourseSettingAbout from './CourseSettingAbout'
import CourseSettingOverview from './CourseSettingOverview'
import {ClassroomSvg} from "../../../../components/Svgs/ClassroomSvg";

const menuItems = [
  {
    key: 'overview',
    label: 'general settings',
    icon: <RiSettings3Line size={16} />,
  },
  {
    key: 'about',
    label: 'about course',
    icon: <BsInfoCircle size={16} />,
  },
  {
    key: 'classes',
    label: 'classes',
    icon: <ClassroomSvg size={16} />,
  },
  {
    key: 'subjects',
    label: 'subjects',
    icon: <RiSubscript size={16} />,
  },
  {
    key: 'delete',
    label: 'delete',
    icon: <BiTrash size={16} />,
  },
]
  .filter(({ invisible = false }) => !invisible)
  .map(({ invisible, ...rest }) => rest)

const routeEntities = [
  {
    path: 'overview',
    label: 'overview',
    component: createCheckPermissions([])(CourseSettingOverview),
  },
  {
    path: 'about',
    label: 'about course',
    component: createCheckPermissions([])(CourseSettingAbout),
  },
  {
    path: 'classes',
    label: 'classes',
    component: createCheckPermissions([])((props) => (
      <CourseContext.Consumer>
        {({ item }) => (
          <CourseClassesManager
            course_id={getId(item)}
            owner_id={getId(item?.owner)}
            owner_type={getType(item?.owner)}
            {...props}
          />
        )}
      </CourseContext.Consumer>
    )),
  },
  {
    path: 'subjects',
    label: 'subjects',
    component: createCheckPermissions([])((props) => (
      <CourseContext.Consumer>
        {({ item }) =>
          bindingRouteSearch({ item, ...props })(CourseSubjectList)
        }
      </CourseContext.Consumer>
    )),
  },
  {
    path: 'delete',
    label: 'delete',
    component: createCheckPermissions([])(({ item }) =>
      createDeleteEntity(item)
    ),
  },
]
  .filter(({ invisible = false }) => !invisible)
  .map(({ path, component: Component, invisible, ...rest }) => ({
    ...rest,
    path,
    key: path,
    component: (props) => (
      <CourseContext.Consumer>
        {({ item }) => (
          <Component
            {...{ item }}
            {...props}
          />
        )}
      </CourseContext.Consumer>
    ),
  }))

export const courseSettings = {
  actions: [
    {
      key: ContextActionTypes.SETTINGS,
      label: 'setting',
      icon: <IoSettingsOutline />,
    },
  ],
  menuItems,
  routeEntities,
}

const CourseSettings = ({ id, ...props }) =>
  createSettingModule([AppEntities.COURSE], {
    item: id,
    ...props,
  })

export default compose(
  notFoundOnError(CourseContext.Consumer),
  withAccessPermissions([permissionCodes.canEdit]),
  withRouter,
  withProps(({ match }) => ({
    id: _.get(match, 'params.id'),
  }))
)(CourseSettings)
